<template>
  <card type="default" header-classes="bg-transparent" class="border border-white;">
    <b-row align-v="center" slot="header">
     &nbsp;&nbsp;<h5 class="h3 mb-0 text-white">CONSOLIDATED DOCUMENT SUMMARY</h5>
    </b-row>
    <b-row>
      <b-col xl="8">
        <apexchart type="donut" width="100%" height="300px" :options="ChartOptionsDocumentSummary" :series="seriesDocumentSummary"></apexchart>
      </b-col>
      <b-col xl="4">
        <b-row>
        <div style="color:white; font-size: 12px;"><b>Total No of Document</b><br><h1 style="color:white;">{{ document_summary.document_total}}</h1></div>
        </b-row>
        <br>
        <br>
        <b-row>
          <div style="color:white; font-size: 12px;"><b>Total Completed Document</b><br><h1 style="color:white;">{{ document_summary.document_completed}}</h1></div>
        </b-row>
      </b-col>
    </b-row>
  </card>
</template>
<script>
  import { BaseProgress } from '@/components';
  import VueApexCharts from 'vue-apexcharts';
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  export default {

    components: {
      BaseProgress,
      "apexchart": VueApexCharts,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        document_summary: {
          document_total : 0,
          document_completed: 0,
        },
        seriesDocumentSummary: [],
        ChartOptionsDocumentSummary:
        {
            colors: ['#119ee1', '#033639', '#ef8215',],
            chart: {
            width: 380,
            type: 'donut',
            },
            plotOptions: {
              pie: {
              startAngle: -90,
              endAngle: 270,
              },
            },
            labels: ["Pending", "Completed", "Overdue",],
            dataLabels: {
            enabled: true
            },
            fill: {
            // type: 'gradient',
            },

            legend: {
            formatter: function(val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex]
            },
            labels: {
            colors: ['white'],
            useSeriesColors: false
            },
          position: 'bottom'
          },
          title: {
          text: ''
          },
        },
      }
    }

  }
</script>
<style>
</style>
